import React, { useMemo, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { isRolePlatformAdmin, token } from "../../modules/auth";
import { renderFormInput } from "../../modules/formTools";
import { required } from "../../modules/validation";
import Loading from "../Loading";
import { ButtonPrimary } from "../Button";
import { Input, Select,Toggle } from "../Form";
import { createAnonCompanyContact, createCompany, createCompanyWithUser } from "../../redux/actions";
import Textarea from "../../ui/Textarea";
import classNames from "classnames";

const v = {
  required: required(),
  initialValues: {}
};
function AnonCompanyClientInfoForm({
  countries,
  industries,
  fullWidth = false,
  isRolePlatformAdmin,
  isRoleEdgeAdmin,
  handleSubmit,
  submitting,
  createAnonCompanyContact,
  createCompanyWithUser,
  includeUserForm = false,
  token,
  agencyId,
  onSuccess,
  companyDomains,
  enquiryId = false
}) {
  const [approvedDomainsWarning, setApprovedDomainsWarning] = useState(null);
  const onSubmit = async formValues => {
    formValues.agency_id = agencyId;
    if(enquiryId){
      formValues.enquiry_id = enquiryId;

    }
    try {
      const response = await createAnonCompanyContact(formValues, token);
      if (onSuccess) {
        onSuccess(response);
      }

      return response;
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <div className="overflow-hidden border-gray-200 sm:rounded-lg">
        <form className="border-none" onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className={`col col-w-full mb-6 ${fullWidth ? "" : "md:col-w-1/2"}`}>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-4">
                  <Field
                    name="company_name"
                    label="Company Name"
                    component={renderFormInput}
                    validate={v.required}
                  />
                </div>
                <div className="w-full px-3 mb-4">
                  <Field
                    name="client_name"
                    label="Client Name"
                    component={renderFormInput}
                    validate={v.required}
                  />
                </div>
                <div className="w-full px-3 mb-4">
                  <Field
                    name="email"
                    label="Email"
                    component={renderFormInput}
                    validate={v.required}
                  />
                </div>
                <div className="w-full px-3 mb-4">
                  <Field
                    name="billing_address"
                    label="Address"
                    component={Textarea}
                    rows={8}
                    validate={v.required}
                    textareaClassName={
                      classNames([
                        "leading-none",
                        "p-2",
                        "w-full",
                        "outline-none",
                        "font-normal",
                        "text-black",
                        "border",
                        "border-grey-md",
                        "w-full",
                        "focus:border-primary",
                        "bg-white",
                        "border-black",
                      ])}
                  />
                </div>
              </div>
              <ButtonPrimary type="submit">
                {submitting ? <Loading inline /> : "Save"}
              </ButtonPrimary>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

const mapStateToProps = (state, props) => {
  return {
    token: token(state),
    isRolePlatformAdmin: isRolePlatformAdmin(state),
  };
};

const mapDispatchToProps = {
  createAnonCompanyContact,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "AnonCompanyClientInfoForm",
    enableReinitialize: true,
    destroyOnUnmount: true,
  })(AnonCompanyClientInfoForm)
);
